import React from 'react';
import { notification } from 'antd';
import CheckedBannerCirlceIcon from '../../../dims-common-ui/components/icons/CheckedBannerCirlceIcon';
import SquareInformationIcon from '../../../dims-common-ui/components/icons/SquareInformationIcon';
import ErrorIcon from '../../../dims-common-ui/components/icons/error-icon/ErrorIcon';
import './notificationMessage.scss';

/**
  * This method is used for open notification message
  * example: Sample param: 
   notificationMessageSuccess:{
        type: 'success',
        placement: 'topRight',
        bottomColor: '#5aa832',
        messageWidth: 250,
        byDefault: true,
        duration:10,
        icon:<CheckedBannerCirlceIcon style={{ color: '#5aa832' }} />,
        description:<div style={{ color: 'black' }}><b>3 cases </b> hase been successfully assigned to <b>Luke Skywalker</b><div style={{ marginTop: 12, marginBottom: 12 }}><a href="#" ><u style={{ color:'black', fontWeight: 500 }}>Undo</u></a></div></div>
      }
  */
export function openNotificationToast(notificationMessage) {
  var icon = notificationMessage.icon;
  var bottomColor = notificationMessage.bottomColor;
  var type = notificationMessage.type;
  if (notificationMessage.byDefault) {
    switch (type) {
      case 'success':
        icon = <CheckedBannerCirlceIcon style={{ color: '#5aa832' }} />;
        bottomColor = '#5aa832';
        break;
      case 'warning':
        icon = undefined; //icon not working
        bottomColor = '';
        break;
      case 'info':
        icon = <SquareInformationIcon style={{ color: '#007dc3' }} />;
        bottomColor = '#007dc3';
        break;
      case 'error':
        icon = <ErrorIcon style={{ color: '#d31c3c' }} />;
        bottomColor = '#d31c3c';
        break;
    }
  }

  let customRows =
    notificationMessage.customActions && notificationMessage.customActions.length > 0 ? (
      notificationMessage.customActions.map((customAction, index) => {
        return (
          <div role="button" key={index} onClick={customAction.onClick} style={{ marginTop: 12, marginBottom: 12 }}>
            {' '}
            <u className="custom-toast-action">{customAction.text}</u>
          </div>
        );
      })
    ) : (
      <div style={{ marginTop: 12, marginBottom: 12 }}></div>
    );
  notification[type]({
    message: notificationMessage.message,
    description: notificationMessage.contentHtml ? (
      <div>
        <div dangerouslySetInnerHTML={{ __html: notificationMessage.contentHtml }} />
        {customRows}
      </div>
    ) : (
      <div>
        {notificationMessage.content}
        {customRows}
      </div>
    ),
    icon: icon,
    onClick: notificationMessage.onClick,
    style: {
      padding: '0px 20px',
      borderBottom: `4px solid ${bottomColor}`,
      borderRadius: '0px',
      backgroundColor: '#ffffff',
      top: '96px',
    },
    duration: notificationMessage.duration,
  });
  notification.config({
    placement: notificationMessage.placement,
    width: notificationMessage.messageWidth,
  });
}
export default {
  openNotificationToast,
};
